import Plyr from 'plyr';
import {v4 as uuidv4} from 'uuid';

const $ = window.jQuery;


const ytVideo = {
    init: () => {
        domCache();
        appendVideoLayer();
        handleLinks();
        handleCloseBtn();
    }
};

const $DOM = {};
const layerVisibleClass = "is-open";
const lockBody = "lock-scroll";

const domCache = () => {
    $DOM.body = $("body");
    $DOM.links = $("a[data-youtubevideoid]");
    $DOM.videoIframeWrapper = $('<div id="yt-iframe-wrapper"></div>');
    $DOM.videoLayer = $('<div id="yt-video-layer"></div>');
    $DOM.closeBtn = $('<button id="yt-video-layer-close"></button>');
    $DOM.inPageVideoContainers = $('.video_player');
}

const handleLinks = () => {
    $DOM.links.on("click", function() {
        playVideo($(this).attr("data-youtubevideoid"))
    });
}

const playVideo = (ytVideoId, $containerElement) => {

    const divId = "plyr-" + uuidv4();
    const $video = $('<div id="'+divId+'" data-plyr-provider="youtube" data-plyr-embed-id="' + ytVideoId + '"></div>')

    if(!$containerElement) {
        $DOM.videoIframeWrapper.append($video);
        $DOM.videoLayer.addClass(layerVisibleClass);
        $DOM.videoIframeWrapper.append($DOM.closeBtn);
        handleCloseBtn();
    }
    else {
        $containerElement
            .empty()
            .append($video)
        ;
    }

    $DOM.body.addClass(lockBody);

    const player = new Plyr('#' + divId, {
        autoplay: true,
        youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1},
        fullscreen : { enabled: true, fallback: true, iosNative: true, container: null },
        loop:{ active: true }
    });

    // player.fullscreen.enter();
    // player.play();

}

const handleCloseBtn = () => {
    $DOM.closeBtn.on("click", function() {
        closeVideo();
    });
}

const closeVideo = () => {
    $DOM.body.removeClass(lockBody);
    $DOM.videoLayer.removeClass(layerVisibleClass);
    $DOM.videoIframeWrapper.empty();
}

const appendVideoLayer = () => {
    $DOM.videoLayer.append($DOM.videoIframeWrapper);
    $DOM.videoIframeWrapper.append($DOM.closeBtn);
    $("body").append($DOM.videoLayer);
}


export default ytVideo;
